import { defineStore } from "pinia";
import FilterApi from "@/api/FilterApi";
import EventApi from "@/api/EventApi";
import ArtistApi from "@/api/ArtistApi";
import VenueApi from "@/api/VenueApi";
import CompanyApi from "@/api/CompanyApi";
import UserApi from "@/api/UserApi";

export const useFilterStore = defineStore("filter", {
  state: () => {
    return {
      results: [],
      filters: {},
      count: 0,
      pageConfig: {},
      currentPage: 1,
      nextPage: null,
      loading: true
    };
  },
  actions: {
    async getConfig(params) {
      let data = await FilterApi.getConfig(params);
      this.pageConfig = data.data || data;
    },
    async getData(params, type) {
      try {
        this.filters = params;
        let data = {};
        if (type === "concerts" || type === "festivals" || type === "both") {
          data = await EventApi.getEvents(params);
          this.results = data.events;
        } else if (type === "artists") {
          data = await ArtistApi.getArtists(params);
          this.results = data.artists;
        } else if (type === "venues") {
          data = await VenueApi.getVenues(params);
          this.results = data.venues;
        } else if (type === "users") {
          data = await UserApi.getUsers(params);
          this.results = data.users;
        } else if (type === "pages") {
          data = await CompanyApi.getCompanies(params);
          this.results = data.companies;
        }
        this.nextPage = data.next_page;
        this.count = data.count;
      } catch (error) {
        this.results = [];
        this.nextPage = null;
        this.count = null;
      }
    }
  }
});
